import { store } from "@/lib/redux/store";
import { getStoredUserInfo } from "./auth";

/**
 * Gets the current user information from Redux store or cookies.
 * @returns An object containing user_id (staffId if available, otherwise id), username, and id
 */
export type CurrentUserInfo = {
  user_id: string;
  username: string;
  id?: string;
  staff_role_id?: string;
};

export const getCurrentUserInfo = (): CurrentUserInfo => {
  // Try to get user info from Redux store first
  let userInfo = store.getState().auth.user.userInfo;
  // If not available in Redux, try to get from cookies
  if (!userInfo) {
    userInfo = getStoredUserInfo();
  }
  // If we have user info, return formatted user_id and username
  if (userInfo) {
    return {
      user_id: userInfo.staffId || userInfo.id, // Use staffId if available, fallback to id
      username: `${userInfo.firstName} ${userInfo.lastName}`,
      id: userInfo.id,
      staff_role_id: userInfo.staffRoleId ?? "",
    };
  }

  // Fallback to empty values if no user info is available
  // This will force the application to handle missing user info appropriately
  return {
    user_id: "",
    username: "",
    id: "",
    staff_role_id: "",
  };
};
